import * as React from 'react';
export const Ic4GSim = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.5 17v-.29l-.29.29h.29zm8.62-14.12A3 3 0 0016 2h-5a2.86 2.86 0 00-1.32.29 3 3 0 00-1.06.84l-3 3.7A3 3 0 005 8.7V19a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-.88-2.12zM11 18h-.5v.5a.5.5 0 01-1 0V18H8a.5.5 0 01-.46-.31.47.47 0 01.11-.54l2-2a.36.36 0 01.16-.15.5.5 0 01.65.27.429.429 0 010 .19V17H11a.5.5 0 010 1zm3.5 1a2 2 0 010-4h.5a.5.5 0 010 1h-.5a1 1 0 10.85 1.5H15a.5.5 0 010-1h1a.5.5 0 01.5.5 2 2 0 01-2 2z'
      fill='currentColor'
    />
  </svg>
);
